import { ChevronLeftIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import classNames from 'classnames';
import { route } from 'next/dist/server/router';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function NavBackButton({ isBackToHomepage = false, className }) {
  const router = useRouter();

  const handleGoBack = () => {
    if (process.browser) {
      if (window.history.length <= 2 || isBackToHomepage) {
        router.replace('/');
      } else {
        router.back();
      }
    }
  };

  return (
    <span onClick={handleGoBack} className={classNames(className)}>
      <ChevronLeftIcon className="h-8 w-8 stroke-1" />
    </span>
  );
}
